
class Ajaxify {
    constructor($mini_cart) {
        let doc = document
        this.qsa = (s, o = doc) => o.querySelectorAll(s),
            this.qs = (s, o = doc) => o.querySelector(s)


        this.$body = document.querySelector('body')
        this.$fader = document.querySelector('.screen-fader')
        this.$mini_cart = $mini_cart
        this.minicart = {
            $wrapper: this.$mini_cart.querySelector('.mini-cart__wrapper'),
            $close: document.querySelector('.close-cart'),
            $trg: document.querySelectorAll('.trg-cart'),
            locale: `${this.$mini_cart.querySelector('.mini-cart__wrapper').dataset.locale}`,
            iso_currency: `${this.$mini_cart.querySelector('.mini-cart__wrapper').dataset.currency}`,
        }

        this.$products__each = document.querySelectorAll('.prod-card__each.has-var, .prod-card__each.no-var') || null
        this.remove_cart = false
        this.added_new = false
        this.first_load = true
        this.openCloseMinicart()
        this.fetchCartPage()
        this.productCard(this.$products__each)

        

        
        // ___________ header product
        this.$header_product = document.querySelectorAll('.header-prod') || null
        if (this.$header_product.length > 0) {
            this.isVariant = document.querySelectorAll('.isvariant') || null
            this.headerProduct(this.$header_product[0])
        }

        // ___________ product-recommendations
        this.prodRecommend = this.qsa('.product-recommendations')
        if(this.prodRecommend.length > 0 ) { 
            this.fectched_reco = false
            this.prodRecco() 
        }
    }











    //? - =========================  RECOMMENDATION PRODUCTS  ========================= -//
    //? - =========================  RECOMMENDATION PRODUCTS  ========================= -//
    prodRecco() {
        this.observer = new ResizeObserver(entries => {
            if( !this.fectched_reco ) {
                let $prod_cards =  document.querySelectorAll('.product-recommendations .prod-card__each')
                if($prod_cards.length < 1 ) return
                this.fectched_reco = true
                this.productCard($prod_cards)
            }
        })
        this.observer.observe(this.$body)
    }



    


    //? - =========================  PARSE PRICE  ========================= -//
    //? - =========================  PARSE PRICE  ========================= -//
    parsePrice(data, $el) {
        let price_right = new Intl.NumberFormat(this.minicart.locale, {
            style: "currency",
            currency: this.minicart.iso_currency
        }).format(data / 100);
        $el.innerHTML = `${price_right}`
    }


    //? - =========================  OPENCLOSE MINICART  ========================= -//
    //? - =========================  OPENCLOSE MINICART  ========================= -//
    openCloseMinicart() {
        let that = this
        function openMinicart() {
            that.$body.classList.add('is-minicart')
        }
        function closeMinicart() {
            that.$body.classList.remove('is-minicart')
        }

        this.minicart.$trg.forEach((el, index) => {
            el.addEventListener('click', () => {
                if (that.$body.classList.contains('is-minicart')) { closeMinicart() }
                else { openMinicart() }
            })
        })

        this.$fader.addEventListener('click', () => {
            that.$body.classList.contains('is-minicart') ? closeMinicart() : null
        })
    }







    //! - =========================  HEADER PRODUCT  ========================= -//
    //! - =========================  HEADER PRODUCT  ========================= -//
    //! - =========================  HEADER PRODUCT  ========================= -//
    //! - =========================  HEADER PRODUCT  ========================= -//
    //! - =========================  HEADER PRODUCT  ========================= -//
    //! - =========================  HEADER PRODUCT  ========================= -//
    //! - =========================  HEADER PRODUCT  ========================= -//
    //! - =========================  HEADER PRODUCT  ========================= -//
    //! - =========================  HEADER PRODUCT  ========================= -//
    //! - =========================  HEADER PRODUCT  ========================= -//
    //! - =========================  HEADER PRODUCT  ========================= -//
    //! - =========================  HEADER PRODUCT  ========================= -//
    //! - =========================  HEADER PRODUCT  ========================= -//
    //! - =========================  HEADER PRODUCT  ========================= -//
    //! - =========================  HEADER PRODUCT  ========================= -//
    //! - =========================  HEADER PRODUCT  ========================= -//
    //! - =========================  HEADER PRODUCT  ========================= -//
    //! - =========================  HEADER PRODUCT  ========================= -//
    headerProduct($header_product) {
        let that = this
        this.header = {
            $el: $header_product,
            $form: $header_product.querySelector('.header-prod__add-cart #AddToCartForm'),
            $btn_submit_cart: $header_product.querySelectorAll('.header-prod__add-cart .btn-submit-cart'),
            $vars: $header_product.querySelectorAll('.header-prod .btn-vars') || null,
            $input_cart: $header_product.querySelector('.header-prod__add-cart .add-to-cart-input'),
            $input_qty: $header_product.querySelector('.header-prod__add-cart .input-qty'),
            $imgs: $header_product.querySelectorAll('.header-prod li.product-single__media') || null,
        }
        
        //verify if is multiple options
        this.$multipleOptions =  this.qsa('variant-picker')
        if(this.$multipleOptions.length > 0) {
            this.is_multiple_options = true
            this.multipleOptions()
        }

        if (this.header.$btn_submit_cart.length < 1) return
        this.onSubmitCart(this.header.$btn_submit_cart[0])

        if (this.header.$vars.length < 1) return
        this.current_var = document.querySelector('.current-var').dataset.id
        this.prod_url = this.header.$el.dataset.url
        this.getVariantData()
        
        //verify if is selling plan
        this.$reset_plans =  this.qsa('.reset-sellplans')
        if(this.$reset_plans.length > 0) {
            this.is_sellingplan = true
        }

        
        
    }


    onSubmitCart($btnSubmitCart){
        let that = this
        $btnSubmitCart.addEventListener('click', (e) => {
            e.preventDefault()
            $btnSubmitCart.classList.add('is-loading','go-spin')
            let item_id = document.querySelector('.header-prod__add-cart .add-to-cart-input').getAttribute('value'),
                item_qty = document.querySelector('.header-prod__add-cart .input-qty').getAttribute('value')

            if (!$btnSubmitCart.classList.contains('selling-submit-cart')) { 
                that.addItemsCart(item_id, item_qty)
            }
            else {
                this.sellingPlan(item_id, item_qty) 
            }
        })
    }


    getVariantData() {
        let that = this
        this.header.$vars.forEach(el => {
            el.addEventListener('click', (e) => {
                e.preventDefault()
                this.header.$vars.forEach(el => el.classList.remove('current-var'))
                this.current_var = el.dataset.id
                el.classList.add('current-var')
                window.history.replaceState({}, '', `${this.prod_url}?variant=${this.current_var}`);
                this.updateVariantInput()
                this.renderProductInfo(el)
                this.updateMedia(el)
            })
        })
    }


    multipleOptions() {
        let that = this
        const $update_form = document.querySelector('.update-form')
        $update_form.addEventListener('click', () => {
            let $newBtnAddToCart = document.querySelectorAll('.header-prod__add-cart .btn-submit-cart')
            if($newBtnAddToCart.length > 0 ) { that.onSubmitCart($newBtnAddToCart[0]) }
            
        })
        
    }






    
    sellingPlan(item_id, item_qty) {
        let sellingPlanSelectors = document.querySelector('.add-to-cart-sp')
        let formData = {
            'items': [{
                'id': item_id,
                'quantity': item_qty,
                selling_plan: sellingPlanSelectors.value
                
            }]
        }


        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
            .then(response => {
                this.remove_cart = true
                this.added_new = true
                this.fetchCartPage()
                return response.json();
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }


    updateMedia(el) {
        if(this.isVariant.length == 0) {
            const var_media = document.querySelector(`[data-media-id="${el.dataset.idMedia}"]`)
            if(window.innerWidth > 1024) {
                window.scrollTo({
                    top: var_media.offsetTop
                    //behavior: "smooth"
                });
            } else {
                document.querySelector('.header-prod__gallery__travel').scrollLeft  = 0
                document.querySelector('.header-prod__gallery__travel').scrollLeft = var_media.getBoundingClientRect().left
            }
        }

    }

    updateVariantInput() {
        const productForms =
            document.querySelectorAll(`form#AddToCartForm, .header-prod__dynamic .shopify-product-form`);

        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.current_var;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }


    renderProductInfo(el) {
        
        let that = this
        that.$body.classList.add('not-click')
        fetch(`${this.prod_url}?variant=${this.current_var}`)
            .then((response) => response.text())
            .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html')

                //replace infos
                const current_infos = document.querySelector('.header-prod__update');
                const new_infos = html.querySelector('.header-prod__update');
                if (new_infos && current_infos) current_infos.replaceWith(new_infos);

                //replace pictures
                if(that.isVariant.length > 0) {
                    const current_pics = document.querySelector('.header-prod__gallery__travel');
                    const new_pics = html.querySelector('.header-prod__gallery__travel');
                    if (new_pics && current_pics) current_pics.replaceWith(new_pics);
                }

                //replace form
                const current_form = document.querySelector('.header-prod__add-cart');
                const new_form = html.querySelector('.header-prod__add-cart');
                // new_form.style.opacity ='.2'
                if (new_form && current_form) current_form.replaceWith(new_form);
                if(that.is_sellingplan) {
                    that.$reset_plans[0].dispatchEvent(new Event('click', { bubbles: false }));
                }



                //replace pickup
                const current_pickup = document.querySelector('.pickup-modal');
                const new_pickup = html.querySelector('.pickup-modal');
                if (new_pickup && current_pickup) current_pickup.replaceWith(new_pickup);

                const current_pickup_bar = document.querySelector('.pickup__location');
                const new_pickup_bar = html.querySelector('.pickup__location');
                if (new_pickup_bar && current_pickup_bar) current_pickup_bar.replaceWith(new_pickup_bar);
                
                const current_pickup_seemore = document.querySelector('.pickup-morelocation');
                const new_pickup_seemore = html.querySelector('.pickup-morelocation');
                if (new_pickup_seemore && current_pickup_seemore) current_pickup_seemore.replaceWith(new_pickup_seemore);
                
                



                //replace pickup





                const $update_form = document.querySelector('.update-form')
                $update_form.dispatchEvent(new Event('click'));
                this.$header_product = document.querySelector('.header-prod')
                let $newSubmitBtn = new_form.querySelectorAll('.header-prod__add-cart .btn-submit-cart')
                if($newSubmitBtn.length > 0) {
                    this.onSubmitCart(new_form.querySelector('.header-prod__add-cart .btn-submit-cart'))
                }
                
                
                this.current_var = document.querySelector('.current-var').dataset.id
                this.prod_url = this.header.$el.dataset.url
                that.$body.classList.remove('not-click')
                if (el.dataset.available == 'false') {
                    document.querySelector('.header-prod__dynamic').style.display = 'none'
                }
                else {
                    document.querySelector('.header-prod__dynamic').style.display = 'block'
                }
            });
    }






    //! - =========================  PRODUCT CARD  ========================= -//
    //! - =========================  PRODUCT CARD  ========================= -//
    //! - =========================  PRODUCT CARD  ========================= -//
    //! - =========================  PRODUCT CARD  ========================= -//
    //! - =========================  PRODUCT CARD  ========================= -//
    //! - =========================  PRODUCT CARD  ========================= -//
    //! - =========================  PRODUCT CARD  ========================= -//
    //! - =========================  PRODUCT CARD  ========================= -//
    //! - =========================  PRODUCT CARD  ========================= -//
    //! - =========================  PRODUCT CARD  ========================= -//
    //! - =========================  PRODUCT CARD  ========================= -//
    //! - =========================  PRODUCT CARD  ========================= -//
    //! - =========================  PRODUCT CARD  ========================= -//
    //! - =========================  PRODUCT CARD  ========================= -//
    //! - =========================  PRODUCT CARD  ========================= -//
    //! - =========================  PRODUCT CARD  ========================= -//
    //! - =========================  PRODUCT CARD  ========================= -//
    //! - =========================  PRODUCT CARD  ========================= -//
    productCard($prod_cards) {
        let that = this
        $prod_cards.forEach((el, index) => {
            const card = {
                vars: el.querySelectorAll('.btn-vars') || null,
                add_to_cart_inp: el.querySelector('.add-to-cart-input'),
                btn_start: el.querySelector('.btn-start-add') || null,
                prices: el.querySelector('.prices'),
                price_total: el.querySelector('.price_total'),
                select_a_var: el.querySelector('.select-var') || null,
                var_single: el.querySelector('.variant-single') || null,
                input_qty: el.querySelector('.input-qty'),
                btn_minus: el.querySelector('.btn-minus'),
                btn_plus: el.querySelector('.btn-plus'),
                display_qty: el.querySelector('.display-qty'),
                $btn_submit_cart: el.querySelectorAll('.btn-submit-cart'),
                $swatch_btns: el.querySelectorAll('.swatch-button') || null,
                $imgs_from_swatch: el.querySelectorAll('.from-swatch') || null,
                $first_image: el.querySelectorAll('picture.img-product') || null,
                $link_prods: el.querySelectorAll('.prod-card__imgs-hold,  .prod-card__title .title-prod') || null
            }
            
            // ______ swatch click
            function swatchChanged(el) {
                let current_swatch = el.dataset.value
                card.$swatch_btns.forEach(element => { element.classList.remove('current-option') })
                el.classList.add('current-option')
                let $current_image = document.querySelectorAll(`.from-swatch.${current_swatch}`)[0]
                if(card.$first_image.length > 0) card.$first_image[0].style.opacity = 0
                card.$imgs_from_swatch.forEach(el => el.classList.remove('current-swatch'))
                $current_image.classList.add('current-swatch')
                card.$link_prods.forEach(el => el.setAttribute('href', $current_image.dataset.url))
            }

            card.$swatch_btns.forEach((el, index) => {
                el.addEventListener('click', () => { swatchChanged(el) })
                el.addEventListener('mouseenter', () => { swatchChanged(el) })
            })

            let currency_symbol = null
            let qty = 1

            if (card.$btn_submit_cart.length > 0) {
                card.$btn_submit_cart[0].addEventListener('click', (e) => {
                    e.preventDefault()
                    let item_id = card.add_to_cart_inp.getAttribute('value'),
                        item_qty = card.input_qty.getAttribute('value')
                    that.addItemsCart(item_id, item_qty)
                })

                // ______ remove all
                function removeAll() {
                    that.$products__each.forEach(el => { el.classList.remove('is-opt-selected', 'to-select') })
                    let is_img_active = document.querySelectorAll('.is-img-var-active')
                    if (is_img_active.length > 0) {
                        is_img_active.forEach(el => el.classList.remove('is-img-var-active'))
                    }

                }



                // ______ select variants
                function selectVariant(el) {
                    removeAll()
                    el.closest('.prod-card__each').classList.add('is-opt-selected')
                    el.closest('.prod-card__each').classList.remove('to-select')
                    el.classList.add('var-selected')
                    currency_symbol = el.dataset.currency
                    qty = 1 //reset qty
                    card.display_qty.innerHTML = `1`
                    card.input_qty.setAttribute('value', 1) //reset qty
                    card.price_total.textContent = `${el.dataset.priceMoney}` //get price
                    card.price_total.dataset.price = `${Number(el.dataset.price.replace(/[^0-9.-]+/g, ""))}` //price without $ and .00
                    card.btn_plus.dataset.maxQty = el.dataset.inventoryQty //set max value qty
                    card.input_qty.setAttribute('max', el.dataset.inventoryQty) //set max value input qty
                    card.add_to_cart_inp.setAttribute('value', el.dataset.id) //set value to cart input
                }
                function removeSelected() {
                    card.vars.forEach(el => {
                        el.classList.remove('var-selected')
                    })
                }


                // ______ single variant
                if (card.var_single) {
                    selectVariant(card.vars[0])
                    el.closest('.prod-card__each').classList.remove('is-opt-selected')
                    el.closest('.prod-card__each').classList.remove('to-select')
                }

                // ______ variants click
                card.vars.forEach((el, index) => {
                    el.addEventListener('click', () => {
                        removeSelected()
                        el.closest('.prod-card__each').classList.contains('is-opt-selected') ? removeAll() : selectVariant(el)
                        el.closest('.prod-card__each').querySelector(`.img-${el.dataset.id}`).classList.add('is-img-var-active')

                    })
                })


                // ______ buy startclick
                if (card.btn_start != null) {
                    card.btn_start.addEventListener('click', () => {
                        removeAll()
                        el.closest('.prod-card__each').classList.add('to-select')
                    })
                }


                // ______ click minus
                card.btn_minus.addEventListener('click', () => {
                    if (qty > 1) {
                        qty--
                        card.display_qty.innerHTML = `${qty}`
                        //card.price_total.textContent = `${currency_symbol}${(card.price_total.dataset.price * qty).toFixed(2)}`
                        card.input_qty.setAttribute('value', qty)
                        this.parsePrice(Number(card.price_total.dataset.price * qty), card.price_total)
                    }
                })

                // ______ click plus
                card.btn_plus.addEventListener('click', () => {
                    if (qty < card.btn_plus.dataset.maxQty) {
                        qty++
                        card.display_qty.innerHTML = `${qty}`
                        //card.price_total.textContent = `${currency_symbol}${(card.price_total.dataset.price * qty).toFixed(2)}`
                        card.input_qty.setAttribute('value', qty)
                        this.parsePrice(Number(card.price_total.dataset.price * qty), card.price_total)
                    }
                })
            }

        })
    }
















    //! - =========================  AJAX MINICART  ========================= -//
    //! - =========================  AJAX MINICART  ========================= -//
    //! - =========================  AJAX MINICART  ========================= -//
    //! - =========================  AJAX MINICART  ========================= -//
    //! - =========================  AJAX MINICART  ========================= -//
    //! - =========================  AJAX MINICART  ========================= -//
    //! - =========================  AJAX MINICART  ========================= -//
    //! - =========================  AJAX MINICART  ========================= -//
    //! - =========================  AJAX MINICART  ========================= -//
    //! - =========================  AJAX MINICART  ========================= -//
    //! - =========================  AJAX MINICART  ========================= -//
    //! - =========================  AJAX MINICART  ========================= -//
    //! - =========================  AJAX MINICART  ========================= -//
    //! - =========================  AJAX MINICART  ========================= -//
    //! - =========================  AJAX MINICART  ========================= -//
    //! - =========================  AJAX MINICART  ========================= -//
    //! - =========================  AJAX MINICART  ========================= -//
    //! - =========================  AJAX MINICART  ========================= -//


    //? - =========================  CART ITEMS  ========================= -//
    //? - =========================  CART ITEMS  ========================= -//
    cartItems() {
        let that = this
        this.line_cart = {
            el: this.qsa('.cart__each'),
            minus: this.qsa('.js-qty-btn-minus'),
            plus: this.qsa('.js-qty-btn-plus'),
            remove: this.qsa('.item-remove')
        }

        this.cart = {
            currency: `${this.minicart.$wrapper.dataset.currency}${this.minicart.$wrapper.dataset.currencySymbol}`,
            symbol: `${this.minicart.$wrapper.dataset.currencySymbol}`,
            $close: document.querySelector('.close-cart'),
            $cart_counter: this.qsa('.cart-qty span'),
            $subtotal: this.qs('.cart__infos__estimated .subtotal__price'),
            current: null,
            $toggle_note: this.$mini_cart.querySelector('.toggle-cartnote__add-note')
        }
        


        this.cart.$close.addEventListener('click', () => {
            that.$body.classList.remove('is-minicart')
        })

        
        document.querySelectorAll('.btn-submit-cart.is-loading').forEach(el => {
            el.classList.remove('is-loading','go-spin')
        })

        this.current_line
        this.bindEvents()
        this.onRemove()
    }








    //? - =========================  ADD ITEMS  ========================= -//
    //? - =========================  ADD ITEMS  ========================= -//
    addItemsCart(item_id, item_qty) {

        let formData = {
            'items': [{
                'id': item_id,
                'quantity': item_qty
            }]
        }

        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
            .then(response => {
                this.remove_cart = true
                this.added_new = true
                this.fetchCartPage()
                return response.json();
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }








    //? - =========================  REMOVE ITEM  ========================= -//
    //? - =========================  REMOVE ITEM  ========================= -//
    onRemove() {
        let that = this
        // ______________ click in minus
        this.line_cart.remove.forEach((el, index) => {
            el.addEventListener('click', (e) => {
                e.preventDefault()
                that.$body.classList.add('is-fetching')

                let changes = {
                    id: el.dataset.id,
                    quantity: 0
                }

                let cart_url = window.Shopify.routes.root + 'cart/change.js'
                fetch(cart_url, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(changes)
                })
                    .then(response => {
                        el.closest('.cart__each').remove()
                        that.updateCart()
                        return response.json();
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    });
            })
        })
    }




    //? - =========================  BIND EVENTS  ========================= -//
    //? - =========================  BIND EVENTS  ========================= -//
    bindEvents() {
        let that = this
        // ______________ click in minus
        this.line_cart.minus.forEach((el, index) => {
            el.addEventListener('click', () => {
                let $line_item = el.closest('.cart__each'),
                    $input_qty = $line_item.querySelector('.js-qty-field'),
                    qty_parameter = $input_qty.getAttribute('value'),
                    $text_qty = $line_item.querySelector('.js-qty-text'),
                    $line_price = $line_item.querySelector('.item-price'),
                    $btn_plus = $line_item.querySelector('.js-qty-btn-plus')


                if (qty_parameter > 1) {
                    $text_qty.innerHTML = `${parseInt(qty_parameter) - 1}`
                    $input_qty.setAttribute('value', `${parseInt(qty_parameter) - 1}`)
                    qty_parameter = parseInt(qty_parameter) - 1
                    $btn_plus.classList.remove('disabled')
                    that.current_line = $input_qty
                    that.onChangeQty(that.current_line)
                    this.parsePrice(Number($line_price.dataset.lineprice * qty_parameter), $line_price)
                }
                qty_parameter == 1 ? el.classList.add('disabled') : null
            })
        })


        // ______________ click in plus
        this.line_cart.plus.forEach((el, index) => {
            el.addEventListener('click', () => {
                let $line_item = el.closest('.cart__each'),
                    $input_qty = $line_item.querySelector('.js-qty-field'),
                    qty_parameter = $input_qty.getAttribute('value'),
                    $text_qty = $line_item.querySelector('.js-qty-text'),
                    $line_price = $line_item.querySelector('.item-price'),
                    $btn_minus = $line_item.querySelector('.js-qty-btn-minus')


                if (qty_parameter < $input_qty.getAttribute('max')) {
                    $text_qty.innerHTML = `${parseInt(qty_parameter) + 1}`
                    $input_qty.setAttribute('value', `${parseInt(qty_parameter) + 1}`)
                    qty_parameter = parseInt(qty_parameter) + 1
                    $btn_minus.classList.remove('disabled')
                    that.current_line = $input_qty
                    that.onChangeQty(that.current_line)
                    this.parsePrice(Number($line_price.dataset.lineprice * qty_parameter), $line_price)
                }
                qty_parameter == parseInt($input_qty.getAttribute('max')) ? el.classList.add('disabled') : null
            })
        })
    }








    //? - =========================  CHANGE QTY  ========================= -//
    //? - =========================  CHANGE QTY  ========================= -//
    onChangeQty(el) {
        let that = this
        this.$body.classList.add('is-fetching')
        let changes = {
            id: el.dataset.id,
            quantity: el.getAttribute('value')
        }

        let cart_url = window.Shopify.routes.root + 'cart/change.js'
        fetch(cart_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(changes)
        })
            .then(response => {
                that.updateCart()
                return response.json();
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }








    //? - =========================  UPDATE CART  ========================= -//
    //? - =========================  UPDATE CART  ========================= -//
    updateCart() {
        fetch(window.Shopify.routes.root + 'cart.js')
            .then((response) => response.json())
            .then((data) => {
                let cents = "";
                if (data.total_price % 100 < 10) {
                    cents = "0";
                }
                let price = parseInt(data.total_price / 100) + "." + cents + data.total_price % 100;
                //this.cart.$subtotal.innerHTML = `${this.cart.currency}: ${price}`
                this.cart.$cart_counter.forEach(el => el.innerHTML = `${data.item_count}`)
                this.$body.classList.remove('is-fetching')
                this.parsePrice(data.total_price, this.cart.$subtotal)

                if (data.item_count < 1) {
                    this.remove_cart = true
                    this.minicart.$trg.forEach(el => el.classList.remove('has-cart'))
                    this.fetchCartPage()

                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }








    //? - =========================  FETCH CART PAGE  ========================= -//
    //? - =========================  FETCH CART PAGE  ========================= -//
    fetchCartPage() {
        let that = this

        let cart_url = window.Shopify.routes.root + 'cart' //STORY DOMAIN
        fetch(cart_url).then(function (response) {
            return response.text();
        })
            .then(function (html) {
                var parser = new DOMParser();
                var doc = parser.parseFromString(html, 'text/html');

                var $cart_body = doc.querySelector('.page-cart__items')
                that.insertCart($cart_body)
                if (that.first_load) {
                    that.first_load = false
                    that.cartItems()
                }
            })
            .catch(function (err) {
                console.warn('Something went wrong.', err);
            });
    }








    //? - =========================  INSERT CART  ========================= -//
    //? - =========================  INSERT CART  ========================= -//
    insertCart($cart_content) {
        let that = this
        $cart_content.querySelector('.toggle-cartnote').addEventListener('click', ()=> {
            that.minicart.$wrapper.classList.toggle('is-cartnote')
        })
        if (this.remove_cart) {
            this.remove_cart = false
            document.querySelector('.page-cart__items').remove()
        }
        this.minicart.$wrapper.appendChild($cart_content)
        if (this.added_new) {
            this.added_new = false
            // this.productCard()
            this.minicart.$trg.forEach(el => {
                el.classList.contains('has-cart') ? null : el.classList.add('has-cart')
            })
            this.cart.$cart_counter.forEach(el => el.innerHTML = `${$cart_content.dataset.cartcounter}`)
            this.cartItems()
            this.$body.classList.add('is-minicart')
        }
    }
}

new Ajaxify(document.querySelector('.mini-cart'))